import IconAsMaskImage from '../IconAsMaskImage'

const FailedIcon = ({ pureSvg, className, color }) => {
  const svg = (
    <>
      <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.3">
          <rect x="6" y="6" width="26" height="26" rx="13" stroke="#D92D20" strokeWidth="2" />
        </g>
        <g opacity="0.1">
          <rect x="1" y="1" width="36" height="36" rx="18" stroke="#D92D20" strokeWidth="2" />
        </g>
        <g clipPath="url(#clip0_7592_4246)">
          <path
            d="M19.0003 15.666V18.9993M19.0003 22.3327H19.0087M27.3337 18.9993C27.3337 23.6017 23.6027 27.3327 19.0003 27.3327C14.398 27.3327 10.667 23.6017 10.667 18.9993C10.667 14.397 14.398 10.666 19.0003 10.666C23.6027 10.666 27.3337 14.397 27.3337 18.9993Z"
            stroke="#D92D20"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_7592_4246">
            <rect width="20" height="20" fill="white" transform="translate(9 9)" />
          </clipPath>
        </defs>
      </svg>
    </>
  )

  if (pureSvg) return svg

  return <IconAsMaskImage {...{ svg, className, color }} />
}

export default FailedIcon
